import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { Reveal } from './ui/Reveal';
const faqs = [{
  q: '¿La sesión es individual?',
  a: 'Sí. La Herradura Dorada es una experiencia privada y personalizada 1:1.'
}, {
  q: '¿Cuánto dura?',
  a: 'La sesión tiene una duración de 45 minutos.'
}, {
  q: '¿Es presencial?',
  a: 'No. La sesión se realiza online.'
}, {
  q: '¿Necesito experiencia previa en desarrollo personal?',
  a: 'No. No necesitas conocimientos previos.'
}, {
  q: '¿La Herradura Dorada es terapia?',
  a: 'No. Es un espacio de acompañamiento y orientación personal y no sustituye terapia psicológica, atención médica ni otros servicios profesionales de salud.'
}, {
  q: '¿Qué ocurre después de la sesión?',
  a: 'Te llevarás una perspectiva más clara sobre tu situación y una hoja de ruta inicial para comenzar a trabajar aquello que identifiquemos.'
}, {
  q: '¿Tengo que saber exactamente qué me está pasando?',
  a: 'No. Precisamente una de las funciones de la sesión es ayudarte a ordenar aquello que hoy puede sentirse confuso.'
}];
const EASE = [0.23, 1, 0.32, 1] as const;
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-champagne px-6 py-20 sm:py-28" data-id="element-54" data-mp="19tlk443aizih">
      <div className="mx-auto max-w-2xl" data-id="element-55" data-mp="1oj17da3m4mtf">
        <Reveal data-id="element-56" data-mp="1ohyg312doicz">
          <h2 className="text-center font-serif text-[1.75rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-57" data-mp="1ohgf5r4rtfyq">
            Preguntas <em className="not-italic text-gold-dark" data-id="element-58" data-mp="1jmj98t2sfmq2">frecuentes</em>
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-59" data-mp="1skv63cu8zgqy">
          <dl className="mt-12 divide-y divide-gold/25 border-y border-gold/25" data-id="element-60" data-mp="1skms1hme25e6">
            {faqs.map((faq, i) => {
            const isOpen = open === i;
            return <div key={faq.q} data-id="element-61" data-mp="3uchowr3zk5cc" data-mpi={i}>
                  <dt data-id="element-62" data-mp="3udjbnsud6g9w">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-5 py-5 text-left transition-colors duration-200 hover:text-gold-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark" data-id="element-63" data-mp="3ue2mkpllk4ef">
                      <span className="font-serif text-lg font-normal leading-snug text-ink sm:text-xl" data-id="element-64" data-mp="2h8qxob577w19">
                        {faq.q}
                      </span>
                      <Plus className={`mt-1 h-4 w-4 flex-shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-65" data-mp="2m4pijorbivwx" />
                    </button>
                  </dt>
                  <AnimatePresence initial={false} data-id="element-66" data-mp="34vgt2tn1kscw">
                    {isOpen && <motion.dd initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: EASE
                }} className="overflow-hidden" data-id="element-67" data-mp="tbhmt2i77zmu">
                        <p className="pb-5 pr-9 text-[16.5px] leading-relaxed text-ink-soft" data-id="element-68" data-mp="1c0xv4c04kwdt">
                          {faq.a}
                        </p>
                      </motion.dd>}
                  </AnimatePresence>
                </div>;
          })}
          </dl>
        </Reveal>
      </div>
    </section>;
}